import AutorizationService from "./AutorizationService";
class RolesService extends AutorizationService {
  constructor() {
    super("roles");
  }
}

export default new RolesService();
